export default "__VITE_ASSET__D9YQdq8m__"